export const capitalizeSkillName = (skillName: string): string => {
  const splitSkillName = skillName.split(' ');
  const capitalizedSkillNameArray = splitSkillName.map((word) => word.charAt(0).toUpperCase() + word.substring(1));

  return capitalizedSkillNameArray.join(' ');
};
